// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const AssetCategoryCodeApprvService = {};

AssetCategoryCodeApprvService.getAssetCategoryCodeApprvList = function (userInput) {
  return lossClient({
    url: "/AssetCategory/approvalItems?pageSize=1000&pageIndex=0",
    method: "get",
  });
};

export default AssetCategoryCodeApprvService;
